import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPytorchComponent } from './simple-icons-pytorch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPytorchComponent ],
    exports:      [ SimpleIconsPytorchComponent ],
    bootstrap:    []
})
export class SimpleIconsPytorchModule {}
